// src/app/authenticated/redirections/dashboard/page.js

"use client"; // This is a client component

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { Center, Spinner } from "@chakra-ui/react";

export default function DashboardRedirectionPage() {
  const { data: session, status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === "loading") {
      // Wait for the session to load
      return;
    }

    if (status === "unauthenticated") {
      router.push("/login");
      return;
    }

    if (session?.user?.role) {
      switch (session.user.role) {
        case "admin":
          router.push("/authenticated/admin/dashboard");
          break;
        case "accountmanager":
        case "accountmanageradmin":
          router.push("/authenticated/manager/dashboard");
          break;
        case "user":
          router.push("/authenticated/user/dashboard"); 
          //router.push(`/authenticated/clients/overview`); 
          break;
        default:
          console.error("Unhandled role:", session.user.role);
          // Optionally redirect to a default page here.
          break;
      }
    } else {
      console.error("User role not found in session.");
      // Optionally handle missing role case.
    }
  }, [session, status, router]);

  // Center the spinner on the page without any text.
  return (
    <Center minH="100vh" minW="100vw" bg="white">
      <Spinner size="xl" color="teal.500" />
    </Center>
  );
}
